module.exports = __webpack_public_path__ + "static/img/Thomas.Bellchambers.3fd9427.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Thomas.Bellchambers.jpg
// module id = nyjD
// module chunks = 0